import { formatDate } from '@spa/shared/utils/date';
import { differenceInDays } from 'date-fns';

export const isValidStay = (start, end, minimumStay, maximumStay, t, language = 'en') => {
  if (!start || !end) {
    return { isValid: true, error: null };
  }

  const stayDuration = differenceInDays(end, start);

  const isMinimumStayInvalid = minimumStay && stayDuration < minimumStay;
  if (isMinimumStayInvalid) {
    const minimumMoveOut = new Date(start);
    minimumMoveOut.setDate(minimumMoveOut.getDate() + minimumStay);

    return {
      isValid: false,
      error: t(
        'This listing requires a minimum stay of {{nights}} nights. Please select a move-out date starting from {{moveOut}}.',
        {
          nights: minimumStay,
          moveOut: formatDate(minimumMoveOut, language, 'dd MMMM yyyy')
        }
      )
    };
  }

  const isMaximumStayInvalid = maximumStay && stayDuration > maximumStay;
  if (isMaximumStayInvalid) {
    const maximumMoveOut = new Date(start);
    maximumMoveOut.setDate(maximumMoveOut.getDate() + maximumStay);

    return {
      isValid: false,
      error: t(
        'The maximum stay for this listing is {{nights}} nights. Please select a move-out date before {{moveOut}}.',
        { nights: maximumStay, moveOut: formatDate(maximumMoveOut, language, 'dd MMMM yyyy') }
      )
    };
  }

  return { isValid: true, error: null };
};
